import { BorrowerDetailsModule } from 'ng2-app/modules/borrower/components/borrower-details/borrower-details.module';
import { BorrowerFactory } from 'ng2-app/modules/borrower/models/borrower/borrower.factory';
import { BorrowerService } from 'ng2-app/modules/borrower/models/borrower/borrower.service';
import { BorrowerStore } from 'ng2-app/modules/borrower/models/borrower/borrower.store';
import { NgModule } from '@angular/core';
import { TaskService } from 'ng2-app/modules/borrower/models/task/task.service';
import { TaskStore } from 'ng2-app/modules/borrower/models/task/task.store';
import { WorkflowService } from 'ng2-app/modules/borrower/services/workflow.service';
import { DealService } from 'ng2-app/modules/borrower/models/deal/deal.service';
import { DealStore } from 'ng2-app/modules/borrower/models/deal/deal.store';
import { DocumentService } from 'ng2-app/modules/borrower/models/document/document.service';
import { RequestService } from './models/request/request.service';
import { RequestStore } from './models/request/request.store';
import { DocumentStore } from './models/document/document.store';
import { DocumentCategoryService } from './models/document-category/document-category.service';
import { DocumentCategoryStore } from './models/document-category/document-category.store';
import {
  ApplicationRequirementsStore
} from 'ng2-app/modules/borrower/models/application-requirements/application-requirements.store';
import { AppFormControlService } from 'ng2-app/modules/borrower/services/app-form-control.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgxPaginationModule,
    BorrowerDetailsModule
  ],
  providers: [
    AppFormControlService,
    ApplicationRequirementsStore,
    BorrowerFactory,
    BorrowerService,
    DealService,
    DealStore,
    RequestService,
    RequestStore,
    DocumentStore,
    BorrowerStore,
    TaskService,
    TaskStore,
    WorkflowService,
    DocumentService,
    DocumentCategoryService,
    DocumentCategoryStore,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class BorrowerModule { }
